var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgAbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_4534",
    "data-name": "Raggruppa 4534",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.798,
    height: 33.528,
    viewBox: "0 0 31.798 33.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-leaves-6263637",
    transform: "translate(11.598 28.595) rotate(-121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9556",
    "data-name": "Tracciato 9556",
    d: "M18.8,7.046c-.812-2.247-2.789-3.385-5.877-3.385h-.409a5.721,5.721,0,0,0-1.469.245,17.512,17.512,0,0,1,3.67,8.354.432.432,0,0,1-.386.472.438.438,0,0,1-.484-.377A16.358,16.358,0,0,0,10.182,4.24,5.4,5.4,0,0,0,7.727,6.649,3.4,3.4,0,0,0,7.8,10.175,29.015,29.015,0,0,0,10.4,13.344c2.048,2.3,4.595,5.148,4.122,6.822-.04.141-.147.519.156.72a.478.478,0,0,0,.576-.04C16.024,20.232,20.561,11.929,18.8,7.046ZM.589,23.556a.5.5,0,0,1-.553-.288c-.141-.349.176-.6.288-.691,1.371-1.069,1-4.877.706-7.937a29.557,29.557,0,0,1-.222-4.082A3.383,3.383,0,0,1,2.824,7.677,5.327,5.327,0,0,1,5.244,7.1a5.675,5.675,0,0,1,1.317.158,4.1,4.1,0,0,0,.323,3.074,17.443,17.443,0,0,1-1.44,4.808.436.436,0,1,0,.784.383A17.875,17.875,0,0,0,7.609,11.4c.593.775,1.348,1.625,2.14,2.509.426.467.9,1.011,1.394,1.59C9,19.889,1.663,23.435.589,23.556ZM10.176,4.238A12.462,12.462,0,0,0,5.411.833.432.432,0,0,1,5.567,0a.447.447,0,0,1,.161.032A13.358,13.358,0,0,1,11.04,3.906a5.713,5.713,0,0,0-.864.331Z",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "noun-music-note-2657433",
    transform: "translate(0 23.741) rotate(-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "music_note",
    "data-name": "music note",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9557",
    "data-name": "Tracciato 9557",
    d: "M2.288,1.375V7.687a1.308,1.308,0,1,0,.327.864V2.784L8.838,1.539v4.51a1.308,1.308,0,1,0,.327.864V0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgAbs);
export default __webpack_public_path__ + "static/media/SvgABS.ec885a70a630499e391ff9375a030943.svg";
export { ForwardRef as ReactComponent };